/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Payment_MethodInputs */

const vi_report_debt_payment_method = /** @type {(inputs: Report_Debt_Payment_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương thức`)
};

/**

* @param {Report_Debt_Payment_MethodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_payment_method = /** @type {((inputs?: Report_Debt_Payment_MethodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Payment_MethodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_payment_method(inputs)
});